export default __webpack_public_path__ + "static/media/Nithing Fang.6aa7e8e7.jpg";